<template>
  <section class="container-sarah">
    <div class="align columns is-vcentered">
      <div class="colum img view-desktop">
        <img
          class="login-section_logo"
          src="~@/assets/images/banners/documents-sarah_receitas.svg"
          alt="Doutores"
        />
      </div>
      <div class="column text">
        <h3>{{ $t('documentos.receitas.subtitulo') }}</h3>
        <p>
          {{ $t('documentos.receitas.descricao-1')
          }}<b>{{ $t('documentos.receitas.descricao-2') }}</b
          >{{ $t('documentos.receitas.descricao-3') }}
        </p>
        <b-button
          class="btn-orange"
          tag="router-link"
          :to="{ name: 'SolicitacaoReceita' }"
        >
          {{ $t('botoes.solicitar') }}
        </b-button>
      </div>
    </div>
    <div class="table">
      <div v-if="Receitas.length === 0" class="container no-data">
        <div class="img-container">
          <img
            src="~@/assets/images/banners/doctors_calendar.svg"
            alt="Receitas"
          />
        </div>
        <h1 class="title">
          {{ $t('documentos.sem-dados.titulo') }}
        </h1>
        <h2 class="subtitle">
          {{ $t('documentos.sem-dados.subtitulo') }}
        </h2>
      </div>
      <b-table
        v-else
        current-page.sync="1"
        per-page="10"
        pagination-position="bottom"
        aria-page-label="Page"
        aria-current-label="Current page"
        :data="Receitas"
        :loading="isLoading"
        :checkable="false"
        :paginated="true"
        :pagination-simple="false"
      >
        <template slot-scope="dados">
          <b-table-column field="Data" label="Data">
            {{ dados.row.Data | formatDate }}
          </b-table-column>
          <b-table-column field="Texto" label="Medicamentos">
            {{ dados.row.Texto }}
          </b-table-column>
          <b-table-column field="DataValidacaoInternet" label="Utilizada em">
            {{ dados.row.DataValidacaoInternet | formatDate }}
          </b-table-column>
          <b-table-column field="Codigo">
            <router-link to="#" class="actions">
              <span
                class="view"
                @click="openReceita(dados.row.Codigo, dados.row.Prontuario)"
              >
                {{ $t('botoes.visualizar') }}
                <i class="icon-ic_link" />
              </span>
            </router-link>
          </b-table-column>
        </template>
      </b-table>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { format, parseISO } from 'date-fns'
import { WindowOpener } from '../../helpers/window.helper'

export default {
  name: 'DocumentosReceitas',
  computed: {
    ...mapGetters({
      isLoading: 'isLoading',
      Receitas: 'getReceitas',
      Documento: 'getDocumento'
    })
  },
  created() {
    this.getReceitas()
  },
  methods: {
    ...mapActions(['getReceitas', 'getReceitaArquivo']),
    async openReceita(codigo, prontuario) {
      let newWin = new WindowOpener(window, navigator)
      await this.getReceitaArquivo({ codigo, prontuario })
        .then(() => {
          const file = new Blob([this.Documento], {
            type: 'application/pdf'
          })
          const fileURL = URL.createObjectURL(file)
          newWin.open(fileURL)
        })
        .catch((err) => {
          throw err
        })
    }
  },
  filters: {
    formatDate(value) {
      if (value == null || value === undefined) return '-'
      return format(parseISO(value), 'dd/MM/yyyy')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/stylesheets/base';
@import '~@/assets/stylesheets/listpagination';
@import '~@/assets/stylesheets/document';

.align {
  .text {
    p {
      margin-bottom: 1.5rem;
    }
  }
}

.actions {
  display: block;
  text-align: right;
  font-weight: $font-semi-bold;

  cursor: pointer;

  i {
    vertical-align: bottom;
  }
}
.actions .view {
  color: var(--light-blue);
  font-size: 0.875rem;

  &.waiting {
    cursor: default;
  }
}

.actions .icon {
  margin-left: 0.625rem;
  display: inline-block;
}

.table {
  thead {
    border-radius: 0.25rem 0.25rem 0 0;

    background-color: var(--neutral-color-5);
    th,
    td {
      border: none;
      vertical-align: middle;
    }
  }
  tbody {
    td {
      vertical-align: middle;
    }
  }
  .actions {
    display: table-cell;
    justify-content: space-between;
    font-weight: $font-semi-bold;

    cursor: pointer;
    i {
      vertical-align: bottom;
    }

    .action-item {
      color: var(--light-blue);
    }

    .action-icon {
      margin-left: 0.15rem;
    }
  }
  .b-checkbox.checkbox input[type='checkbox']:checked + .check {
    background: url('~@/assets/images/icons/ic_check_blue.svg') no-repeat center
      center;

    border-color: var(--light-blue);
    box-shadow: none;
  }

  .b-checkbox.checkbox input[type='checkbox']:hover + .check {
    border-color: var(--light-blue);
  }
}

@media (max-width: 64rem) {
  .align {
    margin-top: 3rem;

    .img {
      margin: 0;
      display: flex;
      justify-content: center;
    }

    .text {
      padding: 0;
      margin-top: 1.5rem;
    }
  }
}

@media (max-width: 64rem) {
  .align {
    margin-top: 3rem;

    .img {
      margin: 0;
      display: flex;
      justify-content: center;
    }

    .text {
      padding: 0;
      margin-top: 1.5rem;
    }
  }
}

@media (min-width: 64rem) {
  .align {
    padding-left: 10%;
    padding-right: 10%;
  }
}
</style>
